import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

import imagesReducer from './post-images/reducer';

const initialPostState = () => ({
    showAllImages: false,
    updating: false,
});

const imageAction = (state, action) => ({...state, images: imagesReducer(state.images, action)});

const postReducer = handleActions(
    {
        [actionTypes.LIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.UNLIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.TAG_IMAGE_SUCCESS]: imageAction,
        [actionTypes.REMOVE_IMAGE_TAG_SUCCESS]: imageAction,
    },
    initialPostState(),
);

const postAction = (state, action) => {
    return state.map(p => {
        return postReducer(p, action);
    });
};

const postsReducer = handleActions(
    {
        [actionTypes.LIKE_IMAGE_SUCCESS]: postAction,
        [actionTypes.UNLIKE_IMAGE_SUCCESS]: postAction,
        [actionTypes.TAG_IMAGE_SUCCESS]: postAction,
        [actionTypes.REMOVE_IMAGE_TAG_SUCCESS]: postAction,
    },
    [],
);

export default postsReducer;
